var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_11499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.917 19.044C19.7015 18.7247 19.4131 18.4615 19.0755 18.276C18.7451 18.0959 18.3748 18.0015 17.9985 18.0015C17.6222 18.0015 17.2519 18.0959 16.9215 18.276C16.5839 18.4614 16.2954 18.7247 16.08 19.044L12.459 24.324C12.1977 24.7245 12.0424 25.1848 12.0075 25.6618C11.9726 26.1387 12.0593 26.6167 12.2595 27.051C12.4545 27.4755 12.7545 27.8355 13.1295 28.0905C13.503 28.3455 13.935 28.488 14.3775 28.5H21.618C22.0663 28.4871 22.5012 28.3449 22.8705 28.0905C23.2455 27.8355 23.5485 27.4755 23.7465 27.0495C23.9439 26.6208 24.0282 26.1487 23.9914 25.6782C23.9547 25.2076 23.798 24.7544 23.5365 24.3615L19.917 19.044Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5C9.79565 19.5 10.5587 19.1839 11.1213 18.6213C11.6839 18.0587 12 17.2956 12 16.5C12 15.7044 11.6839 14.9413 11.1213 14.3787C10.5587 13.8161 9.79565 13.5 9 13.5C8.20435 13.5 7.44129 13.8161 6.87868 14.3787C6.31607 14.9413 6 15.7044 6 16.5C6 17.2956 6.31607 18.0587 6.87868 18.6213C7.44129 19.1839 8.20435 19.5 9 19.5Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5C18.7956 13.5 19.5587 13.1839 20.1213 12.6213C20.6839 12.0587 21 11.2956 21 10.5C21 9.70435 20.6839 8.94129 20.1213 8.37868C19.5587 7.81607 18.7956 7.5 18 7.5C17.2044 7.5 16.4413 7.81607 15.8787 8.37868C15.3161 8.94129 15 9.70435 15 10.5C15 11.2956 15.3161 12.0587 15.8787 12.6213C16.4413 13.1839 17.2044 13.5 18 13.5Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19.5C27.7956 19.5 28.5587 19.1839 29.1213 18.6213C29.6839 18.0587 30 17.2956 30 16.5C30 15.7044 29.6839 14.9413 29.1213 14.3787C28.5587 13.8161 27.7956 13.5 27 13.5C26.2044 13.5 25.4413 13.8161 24.8787 14.3787C24.3161 14.9413 24 15.7044 24 16.5C24 17.2956 24.3161 18.0587 24.8787 18.6213C25.4413 19.1839 26.2044 19.5 27 19.5Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 34.875C27.3195 34.875 34.875 27.3195 34.875 18C34.875 8.6805 27.3195 1.125 18 1.125C8.6805 1.125 1.125 8.6805 1.125 18C1.125 27.3195 8.6805 34.875 18 34.875Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_11499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.ff609ee0eeff20c26459bf2d9d96735f.svg";
export { ForwardRef as ReactComponent };